/**
 * v1.14.61.1.0 — InfoTooltip riusabile per il Wizard v2.
 *
 * Mostra una piccola icona "ⓘ" hoverable/tap-friendly che apre un
 * popover con titolo, body e riferimento tariffario.
 */
import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip, TooltipTrigger, TooltipContent, TooltipProvider,
} from "../../../components/ui/tooltip";

const PALETTE = {
  navy: "#0B2545",
  navyDark: "#06182E",
  gold: "#C9A961",
  cream: "#F8F4ED",
  text: "#3A3A3A",
  muted: "#6E6E6E",
};

export default function InfoTooltip({
  title, body, ref: tariffRef, size = 14, testid,
}) {
  if (!body) return null;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={testid || "info-tooltip"}
            aria-label={title || "Maggiori informazioni"}
            className="inline-flex items-center justify-center align-middle ml-1 rounded-full transition hover:opacity-80"
            style={{
              width: size + 4,
              height: size + 4,
              border: `1px solid ${PALETTE.navy}`,
              color: PALETTE.navy,
              background: "#FFF",
              cursor: "help",
            }}
            onClick={(e) => e.preventDefault()}
          >
            <Info size={size - 2} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          sideOffset={6}
          className="!bg-white !text-[#1A1A1A] !p-3 !max-w-xs !shadow-lg !rounded-lg"
          style={{
            border: `1px solid ${PALETTE.gold}`,
            background: PALETTE.cream,
          }}
        >
          {title && (
            <div
              className="text-xs font-semibold mb-1"
              style={{ color: PALETTE.navyDark }}
            >
              {title}
            </div>
          )}
          <div
            className="text-xs leading-relaxed"
            style={{ color: PALETTE.text }}
          >
            {body}
          </div>
          {tariffRef && (
            <div
              className="text-[10px] mt-1.5 italic"
              style={{ color: PALETTE.muted }}
            >
              Rif.: {tariffRef}
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
